import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { BORROWER_ACTION_TYPE, BORROWERS_ACTION_TYPE } from '../actions';

const initialState = {};

const borrowersReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case BORROWERS_ACTION_TYPE.GET_BORROWERS: {
        return payload || initialState;
      }

      case BORROWER_ACTION_TYPE.DELETE_BORROWER:
        delete draft[meta.borrowerId];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default borrowersReducer;
